module.exports = __webpack_public_path__ + "static/shippingreturns-a13ef1b9433d9eae0a4b3f533c3635d9.jpg";